import React from 'react'
import styled from "styled-components";

const Image = ({ src = null, fit = "cover", height = "auto", width = "100%", dark = false }) => {
    return (
        <Wrap $height={height} $width={width} $fit={fit} $dark={dark}>
            <img src={src} />
        </Wrap>
    )
}

export default Image

const Wrap = styled.div`
    max-width: ${(props) => (props.$width)};
    height: ${(props) => (props.$height)};
    object-fit: ${(props) => (props.$fit)};
    
    & img {
        object-fit: ${(props) => (props.$fit)};
        width: 100%;
        height: 100%;
        
        @media (prefers-color-scheme: dark) {
        filter: ${(props) => (props.$fit ? 'invert(100)' : 'none')};
        }
    }

`